<template>
  <div>
    <card>
      <Button type="primary" size="small" style="margin:5px" @click="addTime">新增</Button>
      <Table :columns="timeTable.columns" :data="timeTable.data"></Table>
    </card>
    <time-form ref="timeForm" v-on:refresh="getTimeList"></time-form>
  </div>
</template>
<script>
  import timeForm from './time_Form'
  export default {
    name:'time_index',
    components: {
      timeForm
    },
    data(){
      return{
        timeTable:{
          columns:[
            {
              title:'开始时间',
              key:'start',
              align:'center'
            },
            {
              title:'结束时间',
              key:'end',
              align:'center'
            },
            {
              title: '操作',
              align: 'center',
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.timeForm.init()
                      this.$refs.timeForm.timeForm.id=params.row.id
                      this.$refs.timeForm.timeForm.start=params.row.start
                      this.$refs.timeForm.timeForm.end=params.row.end
                      this.$refs.timeForm.showModal=true
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title:'确认删除?',
                        content:'确认删除该时间段?',
                        onOk(){
                          this.$api.setting.delTime({id:params.row.id}).then(res=>{
                            if(res.state=="ok"){
                              this.$Message.success("删除成功");
                              self.getTimeList()
                            }else{
                              this.$Message.error(res.msg)
                            }
                          })
                        },
                        onClose(){

                        }
                      })


                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }

          ],
          data:[]
        }
      }
    },
    mounted(){
      this.getTimeList()
    },
    methods:{
      getTimeList(){
        this.timeTable.data=[];
        this.$api.setting.getTimeList().then(res=>{
          this.timeTable.data=res;
        })
      },
      addTime(){
        this.$refs.timeForm.init();
        this.$refs.timeForm.showModal=true
      }
    }
  }
</script>
